export default __webpack_public_path__ + "static/media/mhAiGlobe.f63b17bd.svg";